import { render, staticRenderFns } from "./CustomerEditTemplate.vue?vue&type=template&id=09b2fd6e"
import script from "./CustomerEditTemplate.vue?vue&type=script&lang=ts"
export * from "./CustomerEditTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports